module.exports = __webpack_public_path__ + "static/media/Thumbnail_1.ac482875.png";